<template>
  <div id="listWidget" class="mb-4">
    <div class="completion-card card-item mb-3">
      <div class="completion-header">
        <i class="fa-regular fa-circle-check me-2 text-success"></i>
        <span class="completion-title">{{ props.step }}. 세팅 완료</span>
      </div>
      <div class="completion-body">
        <p class="mb-0">{{ props.subTitle || "wifi 변경이 완료되었습니다." }}</p>
      </div>
    </div>

    <!-- ControllerCard 사용 -->
    <ControllerCard
      v-if="props.controller && props.controller._id"
      :controller="props.controller"
      controller-type="조명제어기"
      mode="wizard-complete"
    />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import ControllerCard from '../ControllerCard.vue';

const props = defineProps(['controller', 'step', 'subTitle']);
</script>

<style scoped>
.completion-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border-color: #198754; /* Success border color */
}

.completion-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #d1e7dd; /* Light green background for success */
  border-bottom: 1px solid #198754; /* Darker green border */
}

.completion-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #198754; /* Success text color */
}

.completion-body {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: #212529;
}

.completion-body p {
  margin-bottom: 0;
}

.completion-header i {
  font-size: 1.5rem;
}
</style>
